var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#333","className":"fill-colored-el","fillRule":"evenodd","d":"M1.757 6l4.046 4.046a.5.5 0 01-.707.707L.303 5.96A.5.5 0 010 5.475a.499.499 0 01.145-.379l4.95-4.95a.5.5 0 11.707.708L1.657 5H13.5a.5.5 0 110 1H1.757z"}));
}

ArrowLeft.defaultProps = {"width":"14","height":"11"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
